import React, { Component } from 'react'
import { Segment, Header } from 'semantic-ui-react'

class Error404 extends Component {
  render() {
    return (
      <Segment basic>
        <Header as="h1">404 Error</Header>
      </Segment>
    )
  }
}

export default Error404
